import React from 'react';
import styled from 'styled-components';

import ContactForm from '../../components/contact-form';
import { Heading, Text, Container, Button, media } from '../../ui-components';
import renderRichText from '../../utils/render-rich-text';
import renderRichTextPreview from '../../utils/render-rich-text-preview';
import LegacyGatedContent from '../legacy-gated-content';

/**
 * Component that renders a rich-text content section block
 *
 * @component SectionRichText
 *
 * @param {object} props
 *
 * @prop {object} sectionData
 * @prop {string} geoSpace
 * @prop {boolean} isPreview
 * @prop {string} slug
 *
 * @return {JSX}
 */
const SectionRichText = props => {
  const { sectionData, geoSpace, isPreview, slug } = props;
  const { title, centerText, richJSON, formType = 'None', formTitle, downloadableContent } = sectionData;

  const downloadWithoutForm = () => {
    const file = downloadableContent?.file;
    if (file) {
      fetch(file.url).then(response => {
        response.blob().then(blob => {
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement('a');
          a.href = url;
          a.download = file.fileName;
          a.click();
        });
      });
    }
  };

  return (
    <>
      <RichContentContainer centerText={centerText}>
        {richJSON && (
          <RichTextContainer>
            <Heading level={2}>{title}</Heading>
            {renderRichText(richJSON, geoSpace)}
          </RichTextContainer>
        )}
        {sectionData.richTextContent && (
          <RichWrapper isPreview={isPreview}>
            <TitleHeading level={2}>{title}</TitleHeading>
            <RichText>{renderRichTextPreview(sectionData.richTextContent)}</RichText>
          </RichWrapper>
        )}
        {formType.toUpperCase() === 'CONTACT' && (
          <RichFormContainer>
            <ContactForm slug={slug} geoSpace={geoSpace} formOnPage eventPage />
          </RichFormContainer>
        )}
        {downloadableContent?.file && formType.toUpperCase() === 'DOWNLOAD' && (
          <RichFormContainer>
            <LegacyGatedContent
              requireForm
              attachment={downloadableContent?.file}
              geoSpace={geoSpace}
              slug={slug}
              title={formTitle || 'Complete to download the attachment.'}
            />
          </RichFormContainer>
        )}
      </RichContentContainer>
      {formType.toUpperCase() === 'DOWNLOAD WITHOUT FORM' && (
        <DownloadWithoutFormButtonContainer>
          <Button onClick={() => downloadWithoutForm()}>Download</Button>
        </DownloadWithoutFormButtonContainer>
      )}
    </>
  );
};

const TitleHeading = styled(props => <Heading {...props} />)`
  margin-bottom: 12px;
`;

const RichWrapper = styled.div`
  width: 100%;
  max-width: ${({ isPreview }) => (isPreview ? '800px' : '')};
`;

const RichText = styled(props => <Text {...props} />)`
  line-height: 32px;
`;

const RichTextContainer = styled(props => <Container {...props} />)`
  padding: 0;

  @media screen and (max-width: ${media.largeBottom}) {
    padding-bottom: 40px;
  }
`;

const RichContentContainer = styled(props => <Container {...props} />)`
  display: flex;
  flex-direction: row;
  padding-bottom: 40px;
  gap: 0;

  ${({ centerText }) => {
    return centerText
      ? `
      text-align: center; 
      ul {
        display: inline-block;
        }`
      : 'text-align: left;';
  }}

  @media screen and (max-width: ${media.largeBottom}) {
    flex-direction: column;
  }
`;

const RichFormContainer = styled.div`
  height: 100%;
  position: sticky;
  top: 128px;
  flex: 1 0 520px;
  padding: 0;
  margin: 0;

  @media screen and (max-width: ${media.largeBottom}) {
    margin-left: 0;
  }
`;

const DownloadWithoutFormButtonContainer = styled(props => <Container {...props} />)`
  display: flex;
  justify-content: center;
  padding-top: 0px;
  padding-bottom: 120px;
`;

export default SectionRichText;

